import React from "react";
import { Card } from "@material-ui/core";
import { SvgIcons } from "../../Icons/SvgIcons/SvgIcons";
import { useStyles } from "./style";

const timeSlots = [
  {
    label: "Morning",
    time: "(8 AM – 12 PM)",
    icon: "sunrise",
  },
  {
    label: "Afternoon",
    time: "(12 PM – 4 PM)",
    icon: "sun",
  },
  {
    label: "Evening",
    time: "(4 PM – 8 PM)",
    icon: "sunset",
  },
];

export const TimeSlotSelector = ({
  selectedTimeRange,
  setSelectedTimeRange,
}) => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      {timeSlots.map((slot, index) => (
        <Card
          key={index}
          className={`${classes.card} ${
            selectedTimeRange === index ? classes.selected : ""
          }`}
          elevation={0}
          onClick={() => setSelectedTimeRange(index)}
        >
          <div>
            <SvgIcons styles={classes.svgIcon} name={slot.icon} />
          </div>
          <div className={classes.title}>{slot.label}</div>
          <div className={classes.subtitle}>{slot.time}</div>
        </Card>
      ))}
    </div>
  );
};
